import { motion } from "framer-motion";
import { waLink } from "@/lib/api";

const WaIcon = () => (
  <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
    <path d="M16 3C9 3 3.3 8.6 3.3 15.6c0 2.5.7 4.8 2 6.8L3.2 29l6.8-2.1c1.9 1 4 1.6 6.1 1.6 7 0 12.7-5.7 12.7-12.7S23 3 16 3zm0 23.2c-2 0-3.9-.6-5.5-1.6l-.4-.2-4 1.2 1.3-3.9-.3-.4c-1.1-1.7-1.7-3.6-1.7-5.6C5.4 9.8 10.1 5.2 16 5.2s10.6 4.7 10.6 10.5S21.9 26.2 16 26.2zm5.8-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.6-1.6-1-.8-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.2 1.4 3.5c.2.2 2.4 3.6 5.7 5 .8.3 1.4.5 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
  </svg>
);

export const WhatsAppFloat = ({ settings }) => (
  <motion.a
    href={waLink(settings?.whatsapp, "Olá! Vim pelo site da S'Designer e tenho uma dúvida.")}
    target="_blank"
    rel="noreferrer"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 220, damping: 16 }}
    whileHover={{ scale: 1.05 }}
    className="group fixed bottom-5 right-5 z-[60] flex items-center gap-3 rounded-full bg-[#25D366] py-3 pl-3 pr-3 text-[#041214] shadow-[0_10px_40px_-8px_rgba(37,211,102,0.6)] md:pr-5"
    data-testid="whatsapp-float-button"
    aria-label="Atendimento ao vivo no WhatsApp"
  >
    <span className="relative flex">
      <span className="absolute inset-0 animate-ping rounded-full bg-white/40" />
      <span className="relative"><WaIcon /></span>
    </span>
    <span className="hidden flex-col leading-tight md:flex">
      <span className="text-sm font-bold">Atendimento ao vivo</span>
      <span className="text-[11px] font-medium opacity-80">Tire suas dúvidas no WhatsApp</span>
    </span>
  </motion.a>
);
